export const translationLivechat_sv_autoClose = {
  livechatSettingsSectionAutoClose: "Inaktiva chattar",
  livechatSettingsAutoCloseEnabled: "Stäng inaktiva chattar automatiskt",
  livechatSettingsAutoCloseEnabledHelp: "När besökaren inte svarar på agentens meddelande.",
  livechatSettingsAutoCloseWarning: "Varna besökaren efter",
  livechatSettingsAutoCloseGrace: "Stäng chatten efter varningen",
  livechatSettingsAutoCloseMinutes: "{minutes} min",
  livechatSettingsAutoCloseHour: "1 timme",
  livechatSettingsAutoCloseHours: "{hours} timmar",
  livechatSettingsAutoCloseNever: "Stängs aldrig om besökaren skrev sist.",
  livechatSettingsAutoCloseTextShow: "Anpassa varningsmeddelande",
  livechatSettingsAutoCloseTextHide: "Dölj varningsmeddelande",
  livechatSettingsAutoCloseText: "Varningsmeddelande",
  livechatSettingsAutoCloseTextPlaceholder:
    "Är du fortfarande där? Den här chatten stängs om {minutes} minuter om vi inte hör från dig.",
  livechatSettingsAutoCloseTextPlaceholderOne:
    "Är du fortfarande där? Den här chatten stängs om 1 minut om vi inte hör från dig.",
  livechatSettingsAutoCloseInvalid:
    "Varna efter måste vara 1 till 1440 minuter och stäng efter varningen 1 till 120 minuter.",
  livechatAutoCloseCountdown: "Stängs om {time} om besökaren inte svarar",
  livechatAutoCloseCardBadge: "Stängs om {time}",
  livechatAutoCloseKeepOpen: "Håll öppen",
  livechatAutoCloseKeepingOpen: "Håller öppen…",
  livechatAutoCloseKeptOpen: "Automatisk stängning är av för den här chatten",
  livechatAutoCloseKeepOpenFailed: "Kunde inte hålla chatten öppen. Försök igen.",
  livechatAutoClosedNotice: "Stängdes automatiskt eftersom besökaren inte svarade.",
  livechatAutoClosingNow: "Stänger…",
};
